import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
import { TabValues } from "./const-enums-types";
const initialDeliveryOrderModalState = TabValues.DELIVERY;
export const initialNewAddressData = null;
export const UpdateOrderDeliveryPickupModalContext = createContext({
    loading: false,
    setLoading: () => { },
    tabValue: initialDeliveryOrderModalState,
    setTabValue: () => { },
    newAddressData: initialNewAddressData,
    setNewAddressData: () => { },
    isModalOpen: false,
    setIsModalOpen: () => { },
});
export const UpdateOrderDeliveryPickupModalContextProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [tabValue, setTabValue] = useState(initialDeliveryOrderModalState);
    const [newAddressData, setNewAddressData] = useState(initialNewAddressData);
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (_jsx(UpdateOrderDeliveryPickupModalContext.Provider, Object.assign({ value: {
            loading,
            setLoading,
            tabValue,
            setTabValue,
            newAddressData,
            setNewAddressData,
            isModalOpen,
            setIsModalOpen
        } }, { children: children })));
};
